import { heroLead, heroStacks, heroSmalls } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-900/40 via-transparent to-accent-700/10" />
      <div className="relative mx-auto max-w-7xl px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-40">
        <div className="flex flex-wrap items-center gap-2 text-[11px] tracking-[0.2em] md:text-xs">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-600/90 px-3 py-1 font-medium tracking-wide">
            <i className="ri-flashlight-line text-sm" />
            今日深挖
          </span>
          <span className="text-background-100/60">黑料社 · 独家调查编辑部</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 主卡 */}
          <article className="lg:col-span-7">
            <a href="#exclusive" className="group block h-full rounded-xl bg-background-950/40 p-6 ring-1 ring-background-100/10 transition-colors hover:bg-background-950/60 md:p-8">
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent-400">{heroLead.kicker}</p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[34px] md:leading-[1.35]">
                {heroLead.title}
              </h2>
              <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-background-100/75 md:text-base">
                {heroLead.summary}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-background-100/10 pt-4 text-xs text-background-100/60">
                <span className="flex items-center gap-2"><i className="ri-edit-2-line" />{heroLead.author}</span>
                <span>{heroLead.date}</span>
                <span>{heroLead.readtime}</span>
                <span className="ml-auto flex items-center gap-3 text-background-100/70">
                  <span className="flex items-center gap-1"><i className="ri-eye-line" />{heroLead.heat}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line" />{heroLead.comments}</span>
                </span>
              </div>
            </a>
          </article>

          {/* 右叠双卡 */}
          <div className="flex flex-col gap-6 lg:col-span-5">
            {heroStacks.map((s) => (
              <article key={s.title}>
                <a href="#dig" className="group flex gap-4 rounded-xl bg-background-100/5 p-4 ring-1 ring-background-100/10 transition-colors hover:bg-background-100/10">
                  <div className="hidden w-[120px] shrink-0 overflow-hidden rounded-md sm:block">
                    <img src={s.img} alt={s.title} className="h-full w-full object-cover object-top" />
                  </div>
                  <div className="min-w-0">
                    <span className="text-[11px] font-semibold tracking-widest text-accent-400">{s.tag}</span>
                    <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-background-50 group-hover:text-accent-300 md:text-lg">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-xs text-background-100/55">{s.meta}</p>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>

        {/* 底部小卡条 */}
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {heroSmalls.map((s) => (
            <a
              key={s.title}
              href="#timeline"
              className="flex items-center gap-3 rounded-lg border-l-2 border-primary-600 bg-background-100/5 px-5 py-4 ring-1 ring-background-100/10 transition-colors hover:bg-background-100/10"
            >
              <span className="whitespace-nowrap text-[11px] font-semibold tracking-widest text-accent-400">{s.tag}</span>
              <span className="font-body text-sm leading-snug text-background-100/85 md:text-[15px]">{s.title}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}